/* ═══════════════════════════════════════════════════
   TrackLab v2 — Runner Selection & Detail Panel
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  TL.runner = {};

  TL.runner.selectRunner = function (el, raceId) {
    var view = document.getElementById('v2Expanded-' + raceId)
            || document.getElementById('v2InlineDetail-' + raceId);
    if (!view) return;
    view.querySelectorAll('.runner').forEach(function (r) { r.classList.remove('sel'); });
    el.classList.add('sel');
    TL.runner._populateDetail(el, raceId);

    // Recolor track horse to match selected runner's silk
    if (TL.track) {
      TL.track.recolorHorse(el.dataset.silkUrl, el.dataset.silkColor, el.dataset.cloth);
    }

    if (TL.analytics) TL.analytics.trackRunnerSelect(el, raceId);
  };

  /**
   * Populate the detail panel using <template> cloning (XSS-safe).
   * Falls back to a simple message if the template element is missing.
   */
  TL.runner._populateDetail = function (el, raceId) {
    var panel = document.getElementById('v2Detail-' + raceId);
    if (!panel) return;

    var tpl = document.getElementById('v2DetailTpl');
    var tagTpl = document.getElementById('v2FormTagTpl');

    // Fallback if templates not available
    if (!tpl) {
      panel.className = 'detail-panel';
      panel.textContent = 'Details are not available right now.';
      return;
    }

    // Read data attributes
    var horse = el.dataset.horse || '';
    var jockey = el.dataset.jockey || '';
    var trainer = el.dataset.trainer || '';
    var score = Number(el.dataset.score) || 0;
    var odds = el.dataset.odds || '';
    var cloth = el.dataset.cloth || '';
    var silkUrl = el.dataset.silkUrl || '';
    var silkColor = el.dataset.silkColor || '';
    var formTagsRaw = el.dataset.formTags || '';

    // Read insight from server-rendered DOM (progressive enhancement)
    var insightNode = el.querySelector('.r-insight');
    var blurb = '';
    var markers = [];
    if (insightNode) {
      var blurbP = insightNode.querySelector('p');
      if (blurbP) blurb = blurbP.textContent || '';
      insightNode.querySelectorAll('li').forEach(function (li) {
        markers.push(li.textContent);
      });
    }
    var bestOdds = el.dataset.bestOdds || '';
    var bestBookmaker = el.dataset.bestBookmaker || '';
    // F4: only keep a value signal when the score beats the implied % of the
    // odds this card displays (bet button shows `bestOdds || odds`).
    var valueScore = parseInt(el.dataset.score, 10);
    var valueSignal = TL.gateValueSignal(valueScore, bestOdds || odds, el.dataset.valueSignal || '');
    var noMarket = el.dataset.noMarket === 'true';

    // Clone template
    var frag = tpl.content.cloneNode(true);

    // Helper to find slots — returns null safely
    function slot(name) { return frag.querySelector('[data-slot="' + name + '"]'); }

    // Horse name (linked to profile if available)
    var horseEl = slot('horse');
    if (horseEl) {
      horseEl.textContent = horse;
      if (el.dataset.horseSlug) horseEl.href = '/horse/' + el.dataset.horseSlug + '/';
    }

    // Silk badge
    var silkEl = slot('silk');
    if (silkEl) {
      if (silkUrl) {
        var img = document.createElement('img');
        img.src = silkUrl;
        img.alt = '';
        silkEl.appendChild(img);
      } else {
        silkEl.style.background = silkColor || 'var(--accent-blue)';
        silkEl.textContent = cloth;
      }
    }

    // Jockey & trainer (linked to profile pages)
    var jockeyEl = slot('jockey');
    var trainerEl = slot('trainer');
    if (jockeyEl) {
      jockeyEl.textContent = jockey;
      if (el.dataset.jockeySlug) jockeyEl.href = '/jockey/' + el.dataset.jockeySlug + '/';
    }
    if (trainerEl) {
      trainerEl.textContent = trainer;
      if (el.dataset.trainerSlug) trainerEl.href = '/trainer/' + el.dataset.trainerSlug + '/';
    }

    // Score
    var sc = TL.scoreTierClass(score);
    var scoreWrap = slot('score-wrap');
    if (scoreWrap) {
      scoreWrap.classList.add(sc);
      if (score >= 45) scoreWrap.classList.add('score-shine');
      if (noMarket) scoreWrap.classList.add('pre-market');
    }
    var scoreEl = slot('score');
    if (scoreEl) {
      scoreEl.textContent = TL.scorePct(score);
      scoreEl.dataset.score = String(score);
      scoreEl.classList.add(sc);
    }
    var scoreLabelEl = slot('score-label');
    if (scoreLabelEl && noMarket) scoreLabelEl.textContent = 'Early score (no odds yet)';

    // Unified odds block + bet button
    var _bookieSlug = function (name) {
      return name.toLowerCase().replace(/[^a-z0-9]/g, '-');
    };

    // Form tags
    var formTags = [];
    if (formTagsRaw) {
      try { formTags = JSON.parse('[' + formTagsRaw + ']'); } catch (e) { /* skip */ }
    }

    var tagsContainer = slot('tags');
    if (tagsContainer) {
      if (formTags.length && tagTpl) {
        formTags.forEach(function (t) {
          var tagFrag = tagTpl.content.cloneNode(true);
          var labelEl = tagFrag.querySelector('[data-slot="tag-label"]');
          var valEl = tagFrag.querySelector('[data-slot="tag-value"]');
          if (labelEl) labelEl.textContent = t.label;
          if (valEl) {
            valEl.textContent = t.value;
            if (t.quality !== 'good') valEl.classList.add('neutral');
          }
          tagsContainer.appendChild(tagFrag);
        });
      } else {
        tagsContainer.remove();
      }
    }

    // Insight box
    var insightEl = slot('insight');
    if (insightEl) {
      if (blurb) {
        var blurbEl = slot('blurb');
        if (blurbEl) blurbEl.textContent = blurb;

        // Standout markers
        var markersEl = slot('markers');
        if (markersEl) {
          if (markers.length) {
            markers.forEach(function (m) {
              var li = document.createElement('li');
              li.textContent = m;
              markersEl.appendChild(li);
            });
          } else {
            markersEl.remove();
          }
        }
      } else {
        insightEl.remove();
      }
    }

    // Unified odds block — combines best odds, bookmaker, and value signal
    var oddsBlock = slot('odds-block');
    if (oddsBlock) {
      var signalEl = slot('odds-signal');
      var oddsEl = slot('odds');
      var bookmakerEl = slot('odds-bookmaker');
      var detailEl = slot('odds-detail');
      var hasValue = valueSignal === 'VALUE' || valueSignal === 'SUPER_VALUE';
      // Same plain-English box as the server-rendered race page (services.value_box),
      // at the same odds the F4 gate uses.
      var box = TL.valueBox(valueScore, bestOdds || odds, el.dataset.valueSignal || '');

      if (hasValue && bestOdds) {
        // Show best odds from recommended bookmaker
        var blockOffer = TL.betting.offerFor(el, TL.betting._rowsFor(el, raceId));
        oddsBlock.classList.add(_bookieSlug(blockOffer.bookie));
        oddsBlock.classList.add(valueSignal === 'SUPER_VALUE' ? 'super-value' : 'value');
        if (signalEl) signalEl.textContent = box.heading;
        if (oddsEl) oddsEl.textContent = (blockOffer.odds === '1/1' ? 'Evens' : blockOffer.odds);
        if (bookmakerEl) bookmakerEl.textContent = blockOffer.displayName || blockOffer.bookie;
        if (detailEl) detailEl.textContent = box.body;
      } else if (odds) {
        // No value — show standard odds
        oddsBlock.classList.add('neutral');
        if (signalEl) signalEl.textContent = box.heading;
        if (oddsEl) oddsEl.textContent = (odds === '1/1' ? 'Evens' : odds);
        if (bookmakerEl) bookmakerEl.remove();
        if (detailEl) detailEl.textContent = box.body;
      } else {
        oddsBlock.remove();
      }
    }

    // Bet button: the recommended bookmaker and its odds inline ("Bet with X 11/10 \u2192").
    // Other bookmakers are offered by the bet panel's split button.
    var betBtn = slot('bet-btn');
    var offer = TL.betting.offerFor(el, TL.betting._rowsFor(el, raceId));
    var recommendedBookie = offer.bookie || '';
    if (betBtn) {
      var btnOdds = offer.odds || '';
      var offerName = offer.displayName || recommendedBookie;
      var bookiePart = offerName ? (' with ' + offerName) : '';
      var oddsPart = btnOdds ? (' <span class="cta-btn-odds">' + btnOdds + '</span>') : '';
      betBtn.innerHTML = 'Bet' + bookiePart + oddsPart + ' <span>\u2192</span>';
      if (offerName && btnOdds) {
        betBtn.setAttribute('aria-label',
          'Bet on ' + horse + ' at ' + TL.betting._oddsLabel(btnOdds) + ' with ' + offerName + ': open bet options');
      }
      betBtn.classList.add('bookie-' + _bookieSlug(recommendedBookie));
      var recColor = TL.betting.getBookmakerColor ? TL.betting.getBookmakerColor(recommendedBookie) : '';
      if (recColor) betBtn.style.backgroundColor = recColor;
    }
    var betCta = slot('bet-cta');
    if (!odds && betCta) betCta.remove();

    // Feedback widget — populate data attributes for this runner
    var fbEl = slot('feedback');
    if (fbEl) {
      fbEl.dataset.entityId = raceId + '_' + horse;
      fbEl.dataset.raceId = raceId;
      fbEl.dataset.horse = horse;
      fbEl.dataset.score = score;
      if (TL.feedback) TL.feedback.restore(frag);
    }

    // Replace panel contents
    panel.className = 'detail-panel';
    panel.innerHTML = '';
    panel.appendChild(frag);
  };

  TL.runner._bookmakerCache = {};

  TL.runner._resolveBookmakers = function (el, raceId, horseName, callback) {
    var inline = el.dataset.allBookmakers;
    if (inline) {
      var parsed = null;
      try { parsed = JSON.parse(inline); } catch (ex) { callback([]); return; }
      // An empty array means "not provided": fall through to cache / API.
      if (!Array.isArray(parsed) || parsed.length) {
        callback(parsed);
        return;
      }
    }

    var cached = TL.runner._bookmakerCache[raceId];
    // Polling may seed the cache with only some horses, so a miss on this
    // horse falls through to the API rather than meaning "no bookmakers".
    if (cached && cached[horseName] && cached[horseName].length) {
      callback(cached[horseName]);
      return;
    }

    // The API takes the race's unique event id (data-event-id on the runner
    // list); the slug in raceId repeats across days. The cache stays keyed by
    // raceId, like the poll that also fills it (one race day per page).
    var host = el.closest ? el.closest('[data-event-id]') : null;
    var eventId = host && host.dataset.eventId;
    if (!eventId) { callback([]); return; }
    fetch('/api/race/' + encodeURIComponent(eventId) + '/bookmakers/')
      .then(function (res) { return res.ok ? res.json() : {}; })
      .then(function (data) {
        // Merge so fresher poll-seeded rows for other horses are not lost.
        var existing = TL.runner._bookmakerCache[raceId] || {};
        TL.runner._bookmakerCache[raceId] = Object.assign({}, data, existing);
        callback(data[horseName] || []);
      })
      .catch(function () { callback([]); });
  };
})();
